module.exports = __webpack_public_path__ + "media/applicants/icon-add-avatar@2x-0cb6f514.png";